import { QueueHistory } from 'types';

export const getMostRecentConditionallyApprovedHistoryItem = (items: QueueHistory[] = []) => {
  if (!items.length) return null;
  return items.reduce((latest, current) => (new Date(current.date) > new Date(latest.date) ? current : latest));
};
